import { MenuItem } from "@mui/material";
import SysRecord from "app/class/record";
import Translate from "component/global/translation/translation-component";
import { useNavigate } from "react-router-dom";
import { navigateFromClick } from "shared/services/navigationClick";

interface HomeMenuItemProps {
    handleClose: () => void;
    currentMenuRecord: SysRecord;
    isSubItem?: boolean;
}
const HomeMenuItem = ({ handleClose, currentMenuRecord, isSubItem }: HomeMenuItemProps) => {
    const navigate = useNavigate();

    const handleLinkTo = (event: React.MouseEvent<HTMLElement>) => {
        if (!currentMenuRecord.link_to) return;

        navigateFromClick(event, navigate, currentMenuRecord.link_to);
        handleClose();
    }

    return (
        <MenuItem
            onClick={handleLinkTo}
            sx={{
                mx: 0.75,
                my: 0.25,
                minHeight: 38,
                borderRadius: 2,
                pl: isSubItem ? 2 : 1.5,
                pr: 1.5,
                color: "text.primary",
                "&:hover": {
                    backgroundColor: "rgba(15, 23, 42, 0.06)",
                },
            }}
            disableRipple
        >
            {/* {isSubItem && <SubdirectoryArrowRightIcon />} */}
            <Translate text={currentMenuRecord.label} variant="body2" />
        </MenuItem>
    )
}

export default HomeMenuItem;
